import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "passivos-error",
  templateUrl: "./passivos-error.component.html",
  styleUrls: ["./passivos-error.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class PassivosErrorComponent implements OnInit {
  @Input() result: any;

  constructor() {}

  ColumnsLiabilities: string[] = [
    "accountManagerName",
    "accountManagerDocument",
    "settlementTypeId",
    "isNewShareholder",
    "portfolioName",
    "portfolioDocument",
    "portfolioBank",
    "portfolioBranch",
    "portfolioAccount",
    "portfolioCetipAccount",
    "operationTypeId",
    "operationValue",
    "isNewFund",
    "fundName",
    "fundDocument",
    "fundAccount",
    "fundAdministrator",
    "quotationDate",
    "settlementDate",
    "annotations",
  ];

  ngOnInit(): void {}
}
